/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
window.Vue = require('vue');

import Vue from 'vue'
import App from './components/AppBase.vue'
import router from "@/router"
import store from "./store"
import vuetify from './plugins/vuetify'
import toast from '@/services/toast'
import InfiniteLoading from 'vue-infinite-loading';

Vue.use(InfiniteLoading)
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

import {
    CHECK_AUTH,
    FETCH_USER,
    ACTIVE_COMP,
    FETCH_EXPCLIENT
} from "@/store/actions.type.js";

import ApiService from "@/common/api.service";
ApiService.init()
// Ensure we checked auth/user/client before each page load.
router.beforeEach((to, from, next) => {
  let compName = to.name
  store.dispatch(ACTIVE_COMP, compName)

  store.dispatch(FETCH_USER).then((resp) => {
    console.log('user check', resp);

    if (resp.error) window.location = '/login'

    return  store.dispatch(FETCH_EXPCLIENT, to.params)
  }).then((resp) => {
    if (resp === 'NO ACTIVE CLIENT'){
      toast.info('No client set. Select one from the drop down');
      if (compName !== 'Dashboard'){
        return next({
          name: 'Dashboard'
        })
      }
    }
    return next()
  })


  //Promise.all([store.dispatch(CHECK_AUTH)]).then(next)
});

if (document.getElementById("app")) {
  new Vue({
    store,
    router,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}
